import { useEffect } from "react";
import axios from "axios";
import Cookies from "js-cookie";
import { useRecoilState, useSetRecoilState, useRecoilValue } from "recoil";
import { useToast } from "@/comn/hooks";
import bookmarkState from "../recoil/bookmarkState";
import { authState } from "../recoil";
import { _TEST1234 } from "./ApiConfig";

const add = async (menuId: any) => {
    const authorization = _TEST1234.AUTHORIZATION;
    const lang = Cookies.get("lang")?.toUpperCase() || "EN";
    const path = `/api/v1/${_TEST1234.PORTAL_TYPE}/comn/menu/usr-menu`;
    try {
        let ori = _TEST1234.PORTAL_API_ORI;
        if (_TEST1234.SYSTEM_GROUP_ORI === "tanoga") {
            ori = process.env.REACT_APP_API_OSCI as string;
        }
        const response = await axios.post(
            // _TEST1234.PORTAL_API_ORI + path,
            ori + path,
            { menuId },
            {
                headers: {
                    Authorization: `Bearer ${authorization}`,
                    "Accept-Language": lang,
                },
            },
        );
        return response.data.usrMenuList.content;
    } catch (error) {
        throw error;
    }
};

const remove = async (menuId: any) => {
    const authorization = _TEST1234.AUTHORIZATION;
    const lang = Cookies.get("lang")?.toUpperCase() || "EN";
    const path = `/api/v1/${_TEST1234.PORTAL_TYPE}/comn/menu/usr-menu`;
    try {
        let ori = _TEST1234.PORTAL_API_ORI;
        if (_TEST1234.SYSTEM_GROUP_ORI === "tanoga") {
            ori = process.env.REACT_APP_API_OSCI as string;
        }
        // const response = await axios.delete(_TEST1234.PORTAL_API_ORI + path, {
        const response = await axios.delete(ori + path, {
            data: { menuId },
            headers: {
                Authorization: `Bearer ${authorization}`,
                "Accept-Language": lang,
            },
        });
        return response.data.usrMenuList.content;
    } catch (error) {
        throw error;
    }
};

const get = async () => {
    const authorization = _TEST1234.AUTHORIZATION;
    const lang = Cookies.get("lang")?.toUpperCase() || "EN";

    const path = `/api/v1/${_TEST1234.PORTAL_TYPE}/comn/menu/usr-menu`;

    try {
        let ori = _TEST1234.PORTAL_API_ORI;
        if (_TEST1234.SYSTEM_GROUP_ORI === "tanoga") {
            ori = process.env.REACT_APP_API_OSCI as string;
        }
        // const response = await axios.get(_TEST1234.PORTAL_API_ORI + path, {
        const response = await axios.get(ori + path, {
            headers: {
                Authorization: `Bearer ${authorization}`,
                "Accept-Language": lang,
            },
        });
        return response.data.usrMenuList.content;
    } catch (error) {
        throw error;
    }
};

const useBookmark = () => {
    const [bookmark, setBookmark] = useRecoilState(bookmarkState);
    const { showToast } = useToast();

    const addBookmark = async (menuId: any) => {
        try {
            const content = await add(menuId);
            setBookmark(content);
            showToast({ content: "msg.osc.00123", type: "info" });
        } catch (error) {
            console.log(error);
        }
    };

    const removeBookmark = async (menuId: any) => {
        try {
            const content = await remove(menuId);
            setBookmark(content);
            showToast({ content: "msg.osc.00124", type: "info" });
        } catch (error) {
            console.log(error);
        }
    };

    return { bookmark, addBookmark, removeBookmark };
};

const BookmarkConfig = () => {
    const auth = useRecoilValue(authState);
    const setBookmark = useSetRecoilState(bookmarkState);

    const getBookmark = async () => {
        try {
            const content = await get();
            setBookmark(content);
        } catch (error) {
            // console.log(error);
        }
    };

    useEffect(() => {
        if (auth.isSignedIn) {
            getBookmark();
        }
    }, [auth.isSignedIn]);

    return null;
};

export { useBookmark };

export default BookmarkConfig;
